import { initializeApp, getApps } from 'firebase/app';
import { getMessaging, isSupported } from 'firebase/messaging';

const firebaseConfig = {
  apiKey: "AIzaSyBje-dY3EdrPYnq_eJd5wDEIK8BPQaoFhM",
  authDomain: "vidyakasam-140525.firebaseapp.com",
  projectId: "vidyakasam-140525",
  storageBucket: "vidyakasam-140525.firebasestorage.app",
  messagingSenderId: "702863620831",
  appId: "1:702863620831:web:81da8e7514c3b5c977876a",
  measurementId: "G-CJ95HKSY8P",
};

// Avoid re-initializing if HMR triggers a re-import
const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApps()[0];

// getMessaging can throw if the browser doesn't support it (e.g. Firefox private mode)
export async function getFirebaseMessaging() {
  const supported = await isSupported();
  if (!supported) return null;
  return getMessaging(app);
}

export default app;
